<template>
 <!--  <a-menu mode="horizontal" @click="handleClick" v-model="current">
    <a-menu-item key="/batch">批量操作</a-menu-item>
  </a-menu> -->
 <span class="titleText">业务数据报表</span>
</template>

<script>
export default {
  name: 'headerTab',
  methods: {
    handleClick ({ key }) {
      // console.log(key)
      this.$router.push(key)
    }
  },
  computed: {
    current: {
      get: function () {
        return [this.$route.path]
      },
      set: function (val) {
        // console.log(val)
      }
    },
    isPromotePage () {
      const path = this.$route.path
      if (/^\/promote/.test(path)) {
        return path
      } else {
        return '/promote'
      }
    }
  }
}
</script>

<style lang='less'>
@import '../../common/styles/varibles.less';
@import '../../common/styles/mixins.less';
.titleText{
  color:#fff;
}
.ant-menu {
  &.ant-menu-submenu-content {
    .ant-menu-item {
      color: #1a1a1a;
    }
  }
  height: 100%;
  width: 100%;
  background-color: @1a;
  color: @hc;
  border-bottom: none;
  .ant-menu-item {
    padding: 0;
    text-align: center;
    border-bottom: none;
    height: 64px;
    width: 64px;
    line-height: 64px;
  }
  .ant-menu-submenu {
    text-align: center;
    border-bottom: none;
    height: 64px;
    width: 64px;
    line-height: 64px;
    .ant-menu-submenu-title {
      padding: 0;
    }
  }
}
</style>
